import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {debounceTime} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ElementsService} from '../../elements.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'as-typeahead',
  templateUrl: './typeahead.component.html',
  styleUrls: ['./typeahead.component.scss']
})
export class TypeaheadComponent implements OnInit {

  @ViewChild('filterField', {static: false}) filterField;

  @Output() onChange = new EventEmitter();
  @Input() data;
  @Input() filterOnKey: string;
  @Input() url;
  @Input() disable: boolean = false;
  @Input() clickPath;
  @Input() ajax: boolean = false;
  @Input() placeholder: string;
  @Input() isTypeahead: boolean = true;
  @Input() width = '175';
  @Input() isSpecialTypeahead: boolean = false;

  @Output() currentSearchTerm = new EventEmitter();

  isEnterEnabled: boolean = false;
  isSearch: boolean = false;

  model;
  originalData;
  clear = false;
  found: number = 0;
  timeout = 1000;
  txtQueryChanged: Subject<string> = new Subject<string>();
  resultsList = [];
  textInput;

  constructor(private http: HttpClient, private _router: Router, private ElementsService: ElementsService) {

    this.txtQueryChanged.pipe(debounceTime(this.timeout)).subscribe((m) => {
      if (!this.isSearch) {
        this.processInput(m);
      }
    });
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == 'Enter') {
      this.searchOnEnterPress();
    }
  }

  ngOnInit() {

    if (typeof this.data == 'object') {
      this.data = Object.entries(this.data);
    }

    this.isSearch = this.ElementsService.isSearchState;
    setTimeout(() => {
      this.filterField['model'] = this.ElementsService.searchTermState;
    });
  }

  setData(data) {

    this.data = data;
    this.originalData = data;
  }

  update(textInput) {
    this.txtQueryChanged.next(textInput);
    this.currentSearchTerm.emit(textInput);
  }

  processInput(input: string) {

    //this is delayed because of the debounce
    this.textInput = input; //used in the template for the pipe
    this.resultsList = this.data.filter((e) => {
        if (!e.name && e[1]) {
          if (this.filterOnKey) {
            return e[1][this.filterOnKey].toString().toLocaleLowerCase().includes(input.toLocaleLowerCase());
          }
          return e[1].toString().toLocaleLowerCase().includes(input.toLocaleLowerCase());
        }
        return e.name.toString().toLocaleLowerCase().includes(input.toLocaleLowerCase());

      }
    );

    let newRemapping = [];
    //usually we have payload with an 'id' key named something else, eg 'MemoID'

    this.resultsList.map((e) => {

      for (let [key, value] of Object.entries(e)) {
        if (key.search(/ID/g) != -1) {
          e['id'] = value;
        }
      }
    });

    if (input.length < 2) {
      this.resultsList = [];
    }
  }

  searchOnEnterPress() {

    //making sure that we execute the typeahead field only
    //using model directly from component as testinput not available because of debounce
    if (this.filterField['model'] != undefined && this.filterField['model'].length > 0) {
      this.isSearch = true;
      this.ElementsService.isSearchState = true;
      this.ElementsService.searchTermState = this.filterField['model'];
      this.ElementsService.resetPaginationState();
      this.ElementsService.isSearchEmitter(true);

      this.onChange.emit(this.filterField['model']);
    }
  }

  clearResults() {
    this.resultsList = [];
    this.isEnterEnabled = false;
    this.ElementsService.resetPaginationState();

  }

  clearSearch() {

    this.ElementsService.resetPaginationState();
    this.resultsList = [];
    this.isEnterEnabled = false;
    this.filterField['model'] = '';
    this.onChange.emit('clear-search-field');
    this.isSearch = false;
    this.ElementsService.isSearchState = false;

  }

  processSpecialTypeahead(id, name) {
    if (this.isSpecialTypeahead && this.filterOnKey) {
      this.onChange.emit(name);
      setTimeout(() => {
        this.filterField['model'] = '';
      });
    } else {
      this.onChange.emit(id);
      setTimeout(() => {
        this.filterField['model'] = name;
      });
    }

    this.resultsList = [];

  }

  ajaxUpdate(filter) {

    this.onChange.emit('preloader');

    let queryString = '?key=' + this.filterOnKey + '&input=' + filter;

    this.http.get(this.url + queryString).subscribe((e) => {
      this.data = e['data'];
      this.found = filter.length;
      this.onChange.emit(e['data']);
    });

  }

}
